var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2605 2.68226C11.0307 2.4092 10.8009 2.28455 10.4505 2.28455H2.69184C2.508 2.28455 2.35863 2.14208 2.34139 1.95153L2.23224 0.621844C2.215 0.420016 2.07138 0.254399 1.87605 0.218189L0.505865 0.0050829C0.27032 -0.0311273 0.0462643 0.129741 0.0060493 0.372527C-0.0341657 0.609971 0.126694 0.841479 0.356495 0.883032C0.867721 0.973986 1.25345 1.39803 1.29572 1.91556L1.75253 7.50831C1.81573 8.29188 2.44768 8.89677 3.21176 8.89677H9.47956C10.2092 8.89677 10.8296 8.3453 10.9331 7.59676L11.4788 3.70268C11.5305 3.34711 11.4903 2.95532 11.2605 2.68226Z",
    fill: "url(#paint0_linear_9308_7415)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9308_7415)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.73206,
    y: 3.87256,
    width: 6.88993,
    height: 4.18236,
    rx: 0.909092,
    fill: "#FF3949",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.04968,
    y: -2.19543,
    width: 21.5948,
    height: 21.741
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.18px)",
      clipPath: "url(#bgblur_0_9308_7415_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4.36364
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9308_7415",
    maskUnits: "userSpaceOnUse",
    x: 2.99976,
    y: 1.3501,
    width: 14,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2.99976,
    y: 1.3501,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6073 13.0441C12.0888 13.0441 11.664 13.4833 11.664 14.0255C11.664 14.5612 12.0889 15.0001 12.6073 15.0001C13.1321 15.0001 13.5565 14.5612 13.5565 14.0255C13.5565 13.4833 13.1321 13.0441 12.6073 13.0441ZM5.57901 13.0441C5.06062 13.0442 4.63565 13.4834 4.63565 14.0255C4.63569 14.5611 5.06065 15 5.57901 15.0001C6.10374 15.0001 6.52916 14.5612 6.5292 14.0255C6.5292 13.4833 6.10376 13.0441 5.57901 13.0441ZM15.4501 2.35559L13.9599 2.58704C13.7476 2.62639 13.591 2.8062 13.5722 3.02551L13.454 4.4718C13.4353 4.67887 13.2729 4.83391 13.0731 4.83411H4.63565C4.2548 4.8342 4.00459 4.9699 3.75479 5.26672C3.5052 5.56363 3.46128 5.98962 3.51748 6.3761L4.11123 10.6105C4.22371 11.4244 4.89893 12.0236 5.69229 12.0236H12.5077C13.3384 12.0234 14.0259 11.3657 14.0946 10.5138L14.6689 3.47766L15.6122 3.30969C15.862 3.2645 16.0367 3.01312 15.9931 2.755C15.9494 2.49109 15.7061 2.31637 15.4501 2.35559Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.6073 13.0441C12.0888 13.0441 11.664 13.4833 11.664 14.0255C11.664 14.5612 12.0889 15.0001 12.6073 15.0001C13.1321 15.0001 13.5565 14.5612 13.5565 14.0255C13.5565 13.4833 13.1321 13.0441 12.6073 13.0441ZM5.57901 13.0441C5.06062 13.0442 4.63565 13.4834 4.63565 14.0255C4.63569 14.5611 5.06065 15 5.57901 15.0001C6.10374 15.0001 6.52916 14.5612 6.5292 14.0255C6.5292 13.4833 6.10376 13.0441 5.57901 13.0441ZM15.4501 2.35559L13.9599 2.58704C13.7476 2.62639 13.591 2.8062 13.5722 3.02551L13.454 4.4718C13.4353 4.67887 13.2729 4.83391 13.0731 4.83411H4.63565C4.2548 4.8342 4.00459 4.9699 3.75479 5.26672C3.5052 5.56363 3.46128 5.98962 3.51748 6.3761L4.11123 10.6105C4.22371 11.4244 4.89893 12.0236 5.69229 12.0236H12.5077C13.3384 12.0234 14.0259 11.3657 14.0946 10.5138L14.6689 3.47766L15.6122 3.30969C15.862 3.2645 16.0367 3.01312 15.9931 2.755C15.9494 2.49109 15.7061 2.31637 15.4501 2.35559Z",
    fill: "#FF5563",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6073 13.0441L12.6073 12.8622H12.6073V13.0441ZM11.664 14.0255L11.4821 14.0255V14.0255H11.664ZM12.6073 15.0001V15.1819H12.6073L12.6073 15.0001ZM13.5565 14.0255H13.7384V14.0255L13.5565 14.0255ZM5.57901 13.0441L5.57895 12.8622H5.57901V13.0441ZM4.63565 14.0255L4.45383 14.0255V14.0255H4.63565ZM5.57901 15.0001V15.1819H5.57895L5.57901 15.0001ZM6.5292 14.0255H6.71102V14.0255L6.5292 14.0255ZM15.4501 2.35559L15.4222 2.17593L15.4226 2.17587L15.4501 2.35559ZM13.9599 2.58704L13.9267 2.40819L13.932 2.40737L13.9599 2.58704ZM13.5722 3.02551L13.391 3.01071L13.391 3.00992L13.5722 3.02551ZM13.454 4.4718L13.6352 4.48661L13.6351 4.48818L13.454 4.4718ZM13.0731 4.83411L13.0733 5.01592H13.0731V4.83411ZM4.63565 4.83411L4.6356 4.65229H4.63565V4.83411ZM3.75479 5.26672L3.61561 5.14973L3.61568 5.14965L3.75479 5.26672ZM3.51748 6.3761L3.69741 6.34993L3.69754 6.35085L3.51748 6.3761ZM4.11123 10.6105L4.29129 10.5852L4.29134 10.5856L4.11123 10.6105ZM12.5077 12.0236L12.5078 12.2054H12.5077V12.0236ZM14.0946 10.5138L13.9134 10.4992L13.9134 10.499L14.0946 10.5138ZM14.6689 3.47766L14.4876 3.46287C14.4944 3.38057 14.5557 3.31313 14.637 3.29866L14.6689 3.47766ZM15.6122 3.30969L15.6446 3.48861L15.6441 3.48869L15.6122 3.30969ZM15.9931 2.755L15.8138 2.7853L15.8137 2.78472L15.9931 2.755ZM12.6073 13.0441L12.6073 13.2259C12.1956 13.2259 11.8458 13.5772 11.8458 14.0255H11.664H11.4821C11.4821 13.3894 11.982 12.8623 12.6073 12.8622L12.6073 13.0441ZM11.664 14.0255L11.8458 14.0255C11.8458 14.4664 12.1948 14.8183 12.6073 14.8183L12.6073 15.0001L12.6073 15.1819C11.9829 15.1819 11.4822 14.656 11.4821 14.0255L11.664 14.0255ZM12.6073 15.0001V14.8183C13.0268 14.8183 13.3747 14.4658 13.3747 14.0255L13.5565 14.0255L13.7384 14.0255C13.7383 14.6567 13.2373 15.1819 12.6073 15.1819V15.0001ZM13.5565 14.0255H13.3747C13.3747 13.5779 13.026 13.2259 12.6073 13.2259V13.0441V12.8622C13.2382 12.8622 13.7384 13.3887 13.7384 14.0255H13.5565ZM5.57901 13.0441L5.57906 13.2259C5.16739 13.226 4.81747 13.5774 4.81747 14.0255H4.63565H4.45383C4.45383 13.3894 4.95386 12.8624 5.57895 12.8622L5.57901 13.0441ZM4.63565 14.0255L4.81747 14.0255C4.8175 14.4663 5.16657 14.8182 5.57906 14.8183L5.57901 15.0001L5.57895 15.1819C4.95473 15.1818 4.45388 14.656 4.45383 14.0255L4.63565 14.0255ZM5.57901 15.0001V14.8183C5.99869 14.8183 6.34735 14.4655 6.34738 14.0255L6.5292 14.0255L6.71102 14.0255C6.71097 14.657 6.20878 15.1819 5.57901 15.1819V15.0001ZM6.5292 14.0255H6.34738C6.34738 13.5781 5.99787 13.2259 5.57901 13.2259V13.0441V12.8622C6.20966 12.8622 6.71102 13.3885 6.71102 14.0255H6.5292ZM15.4501 2.35559L15.478 2.53525L13.9878 2.7667L13.9599 2.58704L13.932 2.40737L15.4222 2.17593L15.4501 2.35559ZM13.9599 2.58704L13.993 2.76581C13.8656 2.78943 13.7656 2.89872 13.7533 3.0411L13.5722 3.02551L13.391 3.00992C13.4165 2.71368 13.6296 2.46335 13.9267 2.40826L13.9599 2.58704ZM13.5722 3.02551L13.7534 3.04032L13.6352 4.48661L13.454 4.4718L13.2728 4.457L13.391 3.01071L13.5722 3.02551ZM13.454 4.4718L13.6351 4.48818C13.6085 4.7822 13.3736 5.01562 13.0733 5.01592L13.0731 4.83411L13.073 4.65229C13.1722 4.65219 13.2621 4.57554 13.2729 4.45542L13.454 4.4718ZM13.0731 4.83411V5.01592H4.63565V4.83411V4.65229H13.0731V4.83411ZM4.63565 4.83411L4.63569 5.01592C4.46802 5.01597 4.33922 5.04557 4.2277 5.1016C4.11499 5.15824 4.00851 5.24761 3.8939 5.3838L3.75479 5.26672L3.61568 5.14965C3.75086 4.98902 3.89439 4.86212 4.06444 4.77668C4.2357 4.69063 4.42243 4.65234 4.6356 4.65229L4.63565 4.83411ZM3.75479 5.26672L3.89396 5.38372C3.69242 5.62347 3.64461 5.98686 3.69741 6.34993L3.51748 6.3761L3.33756 6.40226C3.27796 5.99239 3.31798 5.50379 3.61561 5.14973L3.75479 5.26672ZM3.51748 6.3761L3.69754 6.35085L4.29129 10.5852L4.11123 10.6105L3.93118 10.6357L3.33743 6.40135L3.51748 6.3761ZM4.11123 10.6105L4.29134 10.5856C4.3919 11.3133 4.99342 11.8417 5.69229 11.8417V12.0236V12.2054C4.80444 12.2054 4.05552 11.5355 3.93113 10.6354L4.11123 10.6105ZM5.69229 12.0236V11.8417H12.5077V12.0236V12.2054H5.69229V12.0236ZM12.5077 12.0236L12.5077 11.8417C13.2384 11.8416 13.8519 11.262 13.9134 10.4992L14.0946 10.5138L14.2759 10.5284C14.2 11.4694 13.4385 12.2052 12.5078 12.2054L12.5077 12.0236ZM14.0946 10.5138L13.9134 10.499L14.4876 3.46287L14.6689 3.47766L14.8501 3.49245L14.2758 10.5286L14.0946 10.5138ZM14.6689 3.47766L14.637 3.29866L15.5803 3.13069L15.6122 3.30969L15.6441 3.48869L14.7007 3.65666L14.6689 3.47766ZM15.6122 3.30969L15.5798 3.13078C15.7287 3.10385 15.8413 2.94818 15.8138 2.7853L15.9931 2.755L16.1723 2.72471C16.2321 3.07807 15.9953 3.42515 15.6446 3.48861L15.6122 3.30969ZM15.9931 2.755L15.8137 2.78472C15.7861 2.61786 15.6341 2.51134 15.4776 2.53531L15.4501 2.35559L15.4226 2.17587C15.7782 2.1214 16.1127 2.36432 16.1724 2.72529L15.9931 2.755Z",
    fill: "url(#paint1_linear_9308_7415)",
    mask: "url(#path-3-outside-1_9308_7415)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.49514,
    y: 4.49392,
    width: 8.12203,
    height: 6.42281
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.36px)",
      clipPath: "url(#bgblur_1_9308_7415_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7415)",
    "data-figma-bg-blur-radius": 2.72728
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69091 8.18943H8.42136C8.68374 8.18943 8.88989 7.96996 8.88989 7.70531C8.88989 7.4342 8.68374 7.22119 8.42136 7.22119H6.69091C6.42853 7.22119 6.22238 7.4342 6.22238 7.70531C6.22238 7.96996 6.42853 8.18943 6.69091 8.18943Z",
    fill: "url(#paint2_linear_9308_7415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42114 7.23975H6.69067C6.43901 7.23987 6.24048 7.44402 6.24048 7.70557C6.24061 7.96071 6.43925 8.17125 6.69067 8.17139H8.42114C8.67268 8.17139 8.8712 7.96079 8.87134 7.70557C8.87134 7.44394 8.67292 7.23975 8.42114 7.23975Z",
    stroke: "url(#paint3_linear_9308_7415)",
    strokeOpacity: 0.5,
    strokeWidth: 0.0363637
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7415",
    x: 0.186598,
    y: 1.3271,
    width: 11.9808,
    height: 9.27329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.27273,
    result: "effect1_foregroundBlur_9308_7415"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7415_clip_path",
    transform: "translate(1.04968 2.19543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6073 13.0441C12.0888 13.0441 11.664 13.4833 11.664 14.0255C11.664 14.5612 12.0889 15.0001 12.6073 15.0001C13.1321 15.0001 13.5565 14.5612 13.5565 14.0255C13.5565 13.4833 13.1321 13.0441 12.6073 13.0441ZM5.57901 13.0441C5.06062 13.0442 4.63565 13.4834 4.63565 14.0255C4.63569 14.5611 5.06065 15 5.57901 15.0001C6.10374 15.0001 6.52916 14.5612 6.5292 14.0255C6.5292 13.4833 6.10376 13.0441 5.57901 13.0441ZM15.4501 2.35559L13.9599 2.58704C13.7476 2.62639 13.591 2.8062 13.5722 3.02551L13.454 4.4718C13.4353 4.67887 13.2729 4.83391 13.0731 4.83411H4.63565C4.2548 4.8342 4.00459 4.9699 3.75479 5.26672C3.5052 5.56363 3.46128 5.98962 3.51748 6.3761L4.11123 10.6105C4.22371 11.4244 4.89893 12.0236 5.69229 12.0236H12.5077C13.3384 12.0234 14.0259 11.3657 14.0946 10.5138L14.6689 3.47766L15.6122 3.30969C15.862 3.2645 16.0367 3.01312 15.9931 2.755C15.9494 2.49109 15.7061 2.31637 15.4501 2.35559Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7415",
    x: 3.49514,
    y: 4.49392,
    width: 8.12203,
    height: 6.42281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.909092,
    dy: 0.909092
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.909092
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.223529 0 0 0 0 0.286275 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7415_clip_path",
    transform: "translate(-3.49514 -4.49392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69091 8.18943H8.42136C8.68374 8.18943 8.88989 7.96996 8.88989 7.70531C8.88989 7.4342 8.68374 7.22119 8.42136 7.22119H6.69091C6.42853 7.22119 6.22238 7.4342 6.22238 7.70531C6.22238 7.96996 6.42853 8.18943 6.69091 8.18943Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7415",
    x1: 11.4988,
    y1: 0,
    x2: 5.65472,
    y2: 8.83416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7415",
    x1: 14.0093,
    y1: 3.82384,
    x2: 5.92071,
    y2: 13.7261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7415",
    x1: 6.4115,
    y1: 7.39604,
    x2: 9.36221,
    y2: 7.66109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7415",
    x1: 8.60254,
    y1: 7.54599,
    x2: 6.33791,
    y2: 7.58043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcure);
export default __webpack_public_path__ + "static/media/procure.020731add1e60afd4787976507d9ca75.svg";
export { ForwardRef as ReactComponent };